getUserAccountGiftSubscriptionsWithDetails